/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ArticleIdentifier } from './articleIdentifier';
import { Issue } from './issue';
import { OtherVersion } from './otherVersion';
import { Reference } from './reference';
import { Article } from './article';
import { Author } from './author';
import { Citation } from './citation';
import { Section } from './section';
import { Affiliation } from './affiliation';


/**
 * Artykuł wraz z treścią
 */
export interface ArticleWithContent { 
    articleContentId?: number;
    articleId?: number;
    title?: string;
    titleAbbrev?: string;
    articleType?: string;
    publicationDate?: string;
    gicid?: string;
    pubMedId?: string;
    doi?: string;
    currentLanguage?: string;
    domain?: string;
    anAbstract?: string;
    authors?: Array<Author>;
    affiliations?: Array<Affiliation>;
    otherVersions?: Array<OtherVersion>;
    issue?: Issue;
    fullIssue?: string;
    keywords?: Array<string>;
    htmlViewsCount?: number;
    downloadeCount?: number;
    articleUrl?: string;
    fileType?: ArticleWithContent.FileTypeEnum;
    hasHtml?: boolean;
    hasFile?: boolean;
    free?: boolean;
    pages?: string;
    permission?: ArticleWithContent.PermissionEnum;
    citations?: Array<Citation>;
    sentToEditorialDate?: string;
    acceptedAfterReviewDate?: string;
    additionalInfo?: string;
    abstractContent?: string;
    sections?: Array<Section>;
    references?: Array<Reference>;
    nextArticle?: ArticleIdentifier;
    prevArticle?: ArticleIdentifier;
    articleInIssue?: Array<Article>;
}
export namespace ArticleWithContent {
    export type FileTypeEnum = 'PDF' | 'DOC';
    export const FileTypeEnum = {
        PDF: 'PDF' as FileTypeEnum,
        DOC: 'DOC' as FileTypeEnum
    };
    export type PermissionEnum = 'CAN_READ' | 'SALE' | 'NO_SALE';
    export const PermissionEnum = {
        CAN_READ: 'CAN_READ' as PermissionEnum,
        SALE: 'SALE' as PermissionEnum,
        NO_SALE: 'NO_SALE' as PermissionEnum
    };
}


